import React from "react";
import {cx} from "../../lib/ClassSet";
import "./OrderItem.css";
import format from 'date-fns/format'
import {ExternalOrderTag} from "../../components/MiniTag";
import {fromJS} from "immutable";

const MetaOrderItem = (props) => {

  const {data} = props;

  const classes = cx({
    "item": true,
    "sales-order-list-item": true,
    "u-selected": props.selected,
  })

  return (
    <tr className={classes}>
      <td className="field">{data.get("metaOrderId")}</td>
      <td className="field">{data.get("shopId")}</td>
      <td className="field">{data.get("state")}</td>
      <td className="field">{data.get("name")}</td>
      <td className="field">{data.get("shippingOrderId")}</td>
      <td className="field">{data.get("productSku")}</td>
      <td className="field">{data.get("metaItemId")}</td>
      <td className="field">{data.get("courierId")}</td>
      <td className="field">{data.get("trackingNumber")}</td>
      <td className="field">{data.get("message")}</td>
      <td className="field">{format(data.get("createdAt"), "MMM D, YYYY")}</td>
      <td className="field f-x">
        <ExternalOrderTag source={data.get("source")} />
      </td>
      <td className="field">{data.get("isTestOrder") ? "T" : "F"}</td>
    </tr>
  )
}

export const tableHeader = fromJS([
  { title: "Meta Order #" },
  { title: "Shop Id" },
  { title: "State" },
  { title: "Client Name" },
  { title: "Shipping Order Id" },
  { title: "Product SKU" },
  { title: "Meta Item Id" },
  { title: "Courier Id" },
  { title: "Tracking Number" },
  { title: "Message" },
  { title: "Created at" },
  { title: "Source" },
  { title: "Test?" },
]);

export default MetaOrderItem;